import { PlanTypes } from '@zipari/shared-sbp-models';

export const mockAllPlansByPlanType = [
  {
    id: 9390,
    hsa: false,
    year: 2024,
    price: '19.40',
    plan_type: PlanTypes.medicare_supplemental,
    county: {
      county_name: 'Essex',
      fips_county_code: '34013',
    },
    plan_variation: '00',
    external_id: '70285CA0200016-00',
    internal_name: 'MA026926',
    market_segment: 'individual',
  },
  {
    id: 9391,
    hsa: false,
    year: 2024,
    price: '19.40',
    county: {
      county_name: 'Essex',
      fips_county_code: '34013',
    },
    plan_type: PlanTypes.medical,
  },
];

export const mockFilteredAllPlansByPlanType = [
  {
    id: 9390,
    hsa: false,
    year: 2024,
    price: '19.40',
    county: {
      county_name: 'Essex',
      fips_county_code: '34013',
    },
  },
];
